import { z } from "zod";
import { deviceSubmissionSchema } from "../schemas";

export const decodedDeviceSubmissionSchema = deviceSubmissionSchema
  .omit({ body: true, responseBody: true })
  .extend({
    body64: z.string(),
    decodedBody: z.any().optional(),
    responseBody64: z.string(),
    decodedResponse: z.any().optional(),
  });

export type DecodedDeviceSubmission = z.infer<
  typeof decodedDeviceSubmissionSchema
>;
